import { LRUCache } from "lru-cache";
import { defineNuxtPlugin } from "#app";
let _storeCache = void 0;
export default defineNuxtPlugin(() => {
  const FIVE_MINUTES = 1e3 * 60 * 5;
  if (!_storeCache)
    _storeCache = new LRUCache({
      max: FIVE_MINUTES,
      maxSize: 1e5,
      maxEntrySize: 1e5
    });
  return {
    provide: {
      storeCache: _storeCache
    }
  };
});
